import { Box, Button, Typography } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { GTM } from "@/services/gtm";

export default function PromoCard() {
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 700, md: 700 },

                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                padding: "12px 16px",
                background: "linear-gradient(90deg, #FFEDD4 0%, #FEF3C6 100%)",
                border: "0.8px solid #FFD6A7",
                borderRadius: "16px",
                gap: "8px",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                     alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: "8px",
            }}
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
                <Typography
                    sx={{
                        fontFamily: "Archivo",
                        fontWeight: 400,
                        fontSize: { xs: "13px", md: "16px" },
                        lineHeight: "18px",
                        color: "#4A5565",
                    }}
                >
                    Promo code:
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "Prompt",
                        fontWeight: 700,
                        fontSize: { xs: "16px", md: "22px" },
                        lineHeight: "20px",
                        color: "#101828",
                       
                    }}
                >
                    25% off your first two boxes
                </Typography>
            </Box>

            <Button
                onClick={() => {
                    navigator.clipboard?.writeText("EARLYBIRD");
                    GTM.trackPromoCodeApplied({
                        promoCode: "EARLYBIRD",
                        discountType: "percentage",
                        discountAmount: 25,
                    });
                }}
                sx={{
                    minWidth: 0,
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 2,
                    height: 40,
                    background: "#FFD9A6",
                    border: "0.8px solid #FFD6A7",
                    borderRadius: "10px",
                    textTransform: "none",
                    touchAction: "manipulation",
                    cursor: "pointer",
                    "&:hover": { background: "#FCD39B" },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Archivo",
                        fontWeight: 400,
                        fontSize: { xs: "14px", md: "16px" },
                        lineHeight: "14px",
                        color: "#101828",
                    }}
                >
                    Early Bird
                </Typography>

                    <ContentCopyOutlinedIcon sx={{ width: 16, height: 16, color: "#4A5565" }} />
                </Button>
            </Box>

            <Typography
                sx={{
                    fontFamily: "Archivo",
                    fontWeight: 400,
                    fontSize: { xs: "12px", md: "16px" },
                    lineHeight: { xs: "16px", md: "20px" },
                    color: "#4A5565",
                }}
            >
                Applied automatically at checkout, nothing to enter.
            </Typography>
        </Box>
    );
}
